var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.699,
    height: 16.99,
    viewBox: "0 0 19.699 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5163",
    "data-name": "Group 5163",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5160",
    "data-name": "Group 5160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M10.67,13.02c-.22-.01-.44-.02-.67-.02a12.876,12.876,0,0,0-6.61,1.82A2.922,2.922,0,0,0,2,17.35V19a1,1,0,0,0,1,1h8.26A6.963,6.963,0,0,1,10,16,7.072,7.072,0,0,1,10.67,13.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(6 4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M20.75,16a4.338,4.338,0,0,0-.06-.63l.84-.73a.5.5,0,0,0,.1-.63l-.59-1.02a.488.488,0,0,0-.59-.22l-1.06.36a3.647,3.647,0,0,0-1.08-.63l-.22-1.09a.5.5,0,0,0-.49-.4H16.42a.5.5,0,0,0-.49.4l-.22,1.09a3.647,3.647,0,0,0-1.08.63l-1.06-.36a.5.5,0,0,0-.59.22l-.59,1.02a.5.5,0,0,0,.1.63l.84.73a4.338,4.338,0,0,0-.06.63,4.338,4.338,0,0,0,.06.63l-.84.73a.5.5,0,0,0-.1.63l.59,1.02a.488.488,0,0,0,.59.22l1.06-.36a3.647,3.647,0,0,0,1.08.63l.22,1.09a.5.5,0,0,0,.49.4H17.6a.5.5,0,0,0,.49-.4l.22-1.09a3.647,3.647,0,0,0,1.08-.63l1.06.36a.5.5,0,0,0,.59-.22l.59-1.02a.5.5,0,0,0-.1-.63l-.84-.73A4.338,4.338,0,0,0,20.75,16ZM17,18a2,2,0,1,1,2-2A2.006,2.006,0,0,1,17,18Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIcon);
export default __webpack_public_path__ + "static/media/profileUser_icon.216e57ac39e9e3c6aef7ef708e1f41af.svg";
export { ForwardRef as ReactComponent };